import React, { useState } from 'react';

export interface User {
  name: string;
  email: string;
}

export interface UniversalNavbarProps {
  userType?: 'guest' | 'customer' | 'admin' | 'worker';
  user?: User;
  onLogout?: () => void;
  className?: string;
}

const UniversalNavbar: React.FC<UniversalNavbarProps> = ({
  userType = 'guest',
  user,
  onLogout,
  className = ''
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    setIsMobileMenuOpen(false);
  };

  const navigateToHome = () => {
    window.location.href = '/';
  };

  const getNavItems = () => {
    const baseItems = [];

    if (userType === 'guest') {
      baseItems.push(
        <li key="home">
          <button onClick={() => scrollToSection('home')} className="nav-link-button">
            Inicio
          </button>
        </li>,
        <li key="about">
          <button onClick={() => scrollToSection('about')} className="nav-link-button">
            Acerca de
          </button>
        </li>,
        <li key="contribute">
          <button onClick={() => scrollToSection('contribute')} className="nav-link-button">
            Plantar Árboles
          </button>
        </li>,
        <li key="portal">
          <a href="/customer-portal" className="nav-link">
            Mis Árboles
          </a>
        </li>
      );
    }

    if (userType === 'customer') {
      baseItems.push(
        <li key="home">
          <button onClick={navigateToHome} className="nav-link-button">
            Inicio
          </button>
        </li>,
        <li key="dashboard">
          <a href="/customer-portal" className="nav-link">
            Mi Panel
          </a>
        </li>
      );
    }

    if (userType === 'admin') {
      baseItems.push(
        <li key="home">
          <button onClick={navigateToHome} className="nav-link-button">
            Inicio
          </button>
        </li>,
        <li key="dashboard">
          <a href="/admin-dashboard" className="nav-link">
            Panel de Administrador
          </a>
        </li>
      );
    }

    if (userType === 'worker') {
      baseItems.push(
        <li key="home">
          <button onClick={navigateToHome} className="nav-link-button">
            Inicio
          </button>
        </li>,
        <li key="dashboard">
          <a href="/worker-portal" className="nav-link">
            Portal del Trabajador
          </a>
        </li>
      );
    }

    return baseItems;
  };

  const getUserDisplayName = () => {
    if (!user) return '';
    return user.name.split(' ')[0];
  };

  const getWelcomeMessage = () => {
    if (!user) return '';
    const messages: Record<string, string> = {
      customer: '¡Bienvenido!',
      admin: 'Bienvenido Admin',
      worker: 'Bienvenido'
    };
    return messages[userType as string] || 'Bienvenido';
  };

  return (
    <header className={className}>
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo" onClick={navigateToHome} style={{ cursor: 'pointer' }}>
            <img src="/images/logosintexto.jpg" alt="World Conserve" className="logo-img" />
            <span className="logo-text">World Conserve</span>
          </div>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {getNavItems()}

            {user && isMobileMenuOpen && (
              <li className="mobile-user-info">
                <div className="user-welcome-mobile">
                  {getWelcomeMessage()}, {getUserDisplayName()}!
                </div>
              </li>
            )}

            {user && onLogout && isMobileMenuOpen && (
              <li className="mobile-logout">
                <button onClick={handleLogout} className="nav-link-button logout-button">
                  Cerrar Sesión
                </button>
              </li>
            )}
          </ul>

          <div className="nav-right-desktop">
            {user && (
              <div className="user-welcome-desktop">
                <span className="welcome-text">
                  {getWelcomeMessage()}, <strong>{getUserDisplayName()}</strong>!
                </span>
              </div>
            )}

            {user && onLogout && (
              <button onClick={handleLogout} className="logout-button-desktop">
                Cerrar Sesión
              </button>
            )}
          </div>

          <div
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default UniversalNavbar;
